import React from 'react'
import { connect } from 'react-redux'

import { receiptSelectors } from '../../core/receipt'
import { receiptActions } from '../../core/receipt'

class Items extends React.Component {
  render () {
    return (
      <div>
        <h4>Your receipt items</h4>
        <ul className="items-list">
          {this.props.items.map((el, i) => (
            <li key={i}>
              <span>{el.name} ${el.price}</span>
              {el.isSplit && <span> split {el.split} ways</span>}
              <button className="item-btn" onClick={() => this.props.onClick(i)}>Remove</button>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    items: receiptSelectors.getItems(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onClick: (index) => dispatch(receiptActions.removeItem(index))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Items)



/** WEBPACK FOOTER **
 ** ./src/views/containers/Items.js
 **/